import React from 'react';
import { IconProps } from '../../types/sidebar';
import { FaCircleInfo, FaPlay, FaStar } from 'react-icons/fa6';
import { HiCamera } from 'react-icons/hi';
import { FaListUl } from 'react-icons/fa';
import { PiGridFour } from 'react-icons/pi';
import { RiMessage2Line } from 'react-icons/ri';
import { RiErrorWarningFill } from 'react-icons/ri';
import { CiCalendarDate } from 'react-icons/ci';
import { GrLinkPrevious, GrLinkNext } from 'react-icons/gr';
import { IoIosFlash } from 'react-icons/io';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { MdAccessTimeFilled } from 'react-icons/md';
import { IoMail } from 'react-icons/io5';

export const DashboardIcon = ({ fill }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 16H0V0H16V16Z" stroke="#E5E7EB" />
    <path
      d="M2 2C2 1.44687 1.55313 1 1 1C0.446875 1 0 1.44687 0 2V12.5C0 13.8813 1.11875 15 2.5 15H15C15.5531 15 16 14.5531 16 14C16 13.4469 15.5531 13 15 13H2.5C2.225 13 2 12.775 2 12.5V2ZM14.7063 4.70625C15.0969 4.31563 15.0969 3.68125 14.7063 3.29063C14.3156 2.9 13.6812 2.9 13.2906 3.29063L10 6.58437L8.20625 4.79063C7.81563 4.4 7.18125 4.4 6.79063 4.79063L3.29063 8.29062C2.9 8.68125 2.9 9.31563 3.29063 9.70625C3.68125 10.0969 4.31563 10.0969 4.70625 9.70625L7.5 6.91563L9.29375 8.70938C9.68437 9.1 10.3188 9.1 10.7094 8.70938L14.7094 4.70937L14.7063 4.70625Z"
      fill={fill}
    />
  </svg>
);

export const AssociatesIcon = ({ fill }: IconProps) => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_829_4722)">
      <path
        d="M7.04297 8.89062C5.9821 8.89062 4.96469 8.4692 4.21454 7.71905C3.4644 6.96891 3.04297 5.95149 3.04297 4.89062C3.04297 3.82976 3.4644 2.81234 4.21454 2.0622C4.96469 1.31205 5.9821 0.890625 7.04297 0.890625C8.10384 0.890625 9.12125 1.31205 9.8714 2.0622C10.6215 2.81234 11.043 3.82976 11.043 4.89062C11.043 5.95149 10.6215 6.96891 9.8714 7.71905C9.12125 8.4692 8.10384 8.89062 7.04297 8.89062ZM6.57734 12.1156L5.99609 11.1469C5.79609 10.8125 6.03672 10.3906 6.42422 10.3906H7.04297H7.65859C8.04609 10.3906 8.28672 10.8156 8.08672 11.1469L7.50547 12.1156L8.54922 15.9875L9.67422 11.3969C9.73672 11.1438 9.98047 10.9781 10.2336 11.0437C12.4242 11.5938 14.043 13.575 14.043 15.9312C14.043 16.4625 13.6117 16.8906 13.0836 16.8906H8.96484C8.89922 16.8906 8.83984 16.8781 8.78359 16.8562L8.79297 16.8906H5.29297L5.30234 16.8562C5.24609 16.8781 5.18359 16.8906 5.12109 16.8906H1.00234C0.474219 16.8906 0.0429688 16.4594 0.0429688 15.9312C0.0429688 13.5719 1.66484 11.5906 3.85234 11.0437C4.10547 10.9812 4.34922 11.1469 4.41172 11.3969L5.53672 15.9875L6.58047 12.1156H6.57734Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_829_4722">
        <path
          d="M0.0429688 0.890625H14.043V16.8906H0.0429688V0.890625Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OffersIcon = ({ fill }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 2H10.25C10.3875 2 10.5 2.1125 10.5 2.25V3.5H5.5V2.25C5.5 2.1125 5.6125 2 5.75 2ZM4 2.25V3.5H2C0.896875 3.5 0 4.39687 0 5.5V8.5H6H10H16V5.5C16 4.39687 15.1031 3.5 14 3.5H12V2.25C12 1.28438 11.2156 0.5 10.25 0.5H5.75C4.78438 0.5 4 1.28438 4 2.25ZM16 9.5H10V10.5C10 11.0531 9.55313 11.5 9 11.5H7C6.44688 11.5 6 11.0531 6 10.5V9.5H0V13.5C0 14.6031 0.896875 15.5 2 15.5H14C15.1031 15.5 16 14.6031 16 13.5V9.5Z"
      fill={fill}
    />
  </svg>
);

export const WorkStreamsIcon = ({ fill }: IconProps) => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.5C0 0.946875 0.446875 0.5 1 0.5H13C13.5531 0.5 14 0.946875 14 1.5C14 2.05313 13.5531 2.5 13 2.5H1C0.446875 2.5 0 2.05313 0 1.5ZM2 6.5C2 5.94688 2.44688 5.5 3 5.5H15C15.5531 5.5 16 5.94688 16 6.5C16 7.05312 15.5531 7.5 15 7.5H3C2.44688 7.5 2 7.05312 2 6.5ZM14 11.5C14 12.0531 13.5531 12.5 13 12.5H1C0.446875 12.5 0 12.0531 0 11.5C0 10.9469 0.446875 10.5 1 10.5H13C13.5531 10.5 14 10.9469 14 11.5Z"
      fill={fill}
    />
  </svg>
);

export const ReviewsIcon = ({ fill }: IconProps) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.90352 1.0625C9.7379 0.71875 9.3879 0.5 9.00352 0.5C8.61915 0.5 8.27227 0.71875 8.10352 1.0625L6.09415 5.19688L1.60665 5.85938C1.23165 5.91563 0.919147 6.17812 0.803522 6.5375C0.687897 6.89687 0.781647 7.29375 1.0504 7.55937L4.30665 10.7812L3.5379 15.3344C3.4754 15.7094 3.63165 16.0906 3.94102 16.3125C4.2504 16.5344 4.65977 16.5625 4.99727 16.3844L9.00665 14.2437L13.016 16.3844C13.3535 16.5625 13.7629 16.5375 14.0723 16.3125C14.3816 16.0875 14.5379 15.7094 14.4754 15.3344L13.7035 10.7812L16.9598 7.55937C17.2285 7.29375 17.3254 6.89687 17.2066 6.5375C17.0879 6.17812 16.7785 5.91563 16.4035 5.85938L11.9129 5.19688L9.90352 1.0625Z"
      fill={fill}
    />
  </svg>
);

export const EarningsIcon = ({ fill }: IconProps) => (
  <svg
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00005 0.5C5.55317 0.5 6.00005 0.946875 6.00005 1.5V2.61562C6.05005 2.62187 6.09692 2.62812 6.14692 2.6375C6.15942 2.64062 6.1688 2.64062 6.1813 2.64375L7.6813 2.91875C8.22505 3.01875 8.58442 3.54063 8.48442 4.08125C8.38442 4.62187 7.86255 4.98438 7.32192 4.88438L5.83755 4.6125C4.85942 4.46875 3.99692 4.56563 3.39067 4.80625C2.78442 5.04688 2.54067 5.37812 2.48442 5.68437C2.42192 6.01875 2.4688 6.20625 2.52192 6.32188C2.57817 6.44375 2.69379 6.58125 2.92192 6.73438C3.43129 7.06875 4.21255 7.2875 5.22505 7.55625L5.31567 7.58125C6.20942 7.81875 7.30317 8.10625 8.11567 8.6375C8.55942 8.92812 8.97817 9.32187 9.23755 9.87187C9.50317 10.4312 9.55942 11.0563 9.43754 11.7219C9.22192 12.9094 8.40317 13.7031 7.38755 14.1187C6.95942 14.2937 6.4938 14.4062 6.00005 14.4625V15.5C6.00005 16.0531 5.55317 16.5 5.00005 16.5C4.44692 16.5 4.00005 16.0531 4.00005 15.5V14.4094C3.98755 14.4062 3.97192 14.4062 3.95942 14.4031H3.95317C3.19067 14.2844 1.93755 13.9563 1.0938 13.5813C0.59067 13.3562 0.362545 12.7656 0.587545 12.2625C0.812545 11.7594 1.40317 11.5312 1.9063 11.7563C2.55942 12.0469 3.63442 12.3344 4.25629 12.4312C5.25317 12.5781 6.07505 12.4937 6.6313 12.2656C7.15942 12.05 7.40005 11.7375 7.4688 11.3625C7.52817 11.0312 7.4813 10.8406 7.42817 10.725C7.3688 10.6 7.25317 10.4625 7.02192 10.3094C6.50942 9.975 5.72505 9.75625 4.70942 9.4875L4.62192 9.46562C3.7313 9.22812 2.63755 8.9375 1.82505 8.40625C1.3813 8.11562 0.96567 7.71875 0.706295 7.16875C0.443795 6.60938 0.39067 5.98438 0.51567 5.31875C0.74067 4.125 1.63442 3.35 2.65005 2.94688C3.06567 2.78125 3.52192 2.66875 4.00005 2.60313V1.5C4.00005 0.946875 4.44692 0.5 5.00005 0.5Z"
      fill={fill}
    />
  </svg>
);

export const ClientsIcon = ({ fill }: IconProps) => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 0.5C5.16304 0.5 5.79893 0.763392 6.26777 1.23223C6.73661 1.70107 7 2.33696 7 3C7 3.66304 6.73661 4.29893 6.26777 4.76777C5.79893 5.23661 5.16304 5.5 4.5 5.5C3.83696 5.5 3.20107 5.23661 2.73223 4.76777C2.26339 4.29893 2 3.66304 2 3C2 2.33696 2.26339 1.70107 2.73223 1.23223C3.20107 0.763392 3.83696 0.5 4.5 0.5ZM16 0.5C16.663 0.5 17.2989 0.763392 17.7678 1.23223C18.2366 1.70107 18.5 2.33696 18.5 3C18.5 3.66304 18.2366 4.29893 17.7678 4.76777C17.2989 5.23661 16.663 5.5 16 5.5C15.337 5.5 14.7011 5.23661 14.2322 4.76777C13.7634 4.29893 13.5 3.66304 13.5 3C13.5 2.33696 13.7634 1.70107 14.2322 1.23223C14.7011 0.763392 15.337 0.5 16 0.5ZM0 9.83438C0 7.99375 1.49375 6.5 3.33437 6.5H4.66875C5.16562 6.5 5.6375 6.60938 6.0625 6.80312C6.02187 7.02812 6.00313 7.2625 6.00313 7.5C6.00313 8.69375 6.52812 9.76562 7.35625 10.5C7.35 10.5 7.34375 10.5 7.33437 10.5H0.665625C0.3 10.5 0 10.2 0 9.83438ZM12.6656 10.5C12.6594 10.5 12.6531 10.5 12.6438 10.5C13.475 9.76562 13.9969 8.69375 13.9969 7.5C13.9969 7.2625 13.975 7.03125 13.9375 6.80312C14.3625 6.60625 14.8344 6.5 15.3313 6.5H16.6656C18.5063 6.5 20 7.99375 20 9.83438C20 10.2031 19.7 10.5 19.3344 10.5H12.6656ZM7 7.5C7 6.70435 7.31607 5.94129 7.87868 5.37868C8.44129 4.81607 9.20435 4.5 10 4.5C10.7956 4.5 11.5587 4.81607 12.1213 5.37868C12.6839 5.94129 13 6.70435 13 7.5C13 8.29565 12.6839 9.05871 12.1213 9.62132C11.5587 10.1839 10.7956 10.5 10 10.5C9.20435 10.5 8.44129 10.1839 7.87868 9.62132C7.31607 9.05871 7 8.29565 7 7.5ZM4 15.6656C4 13.3656 5.86562 11.5 8.16562 11.5H11.8344C14.1344 11.5 16 13.3656 16 15.6656C16 16.125 15.6281 16.5 15.1656 16.5H4.83437C4.375 16.5 4 16.1281 4 15.6656Z"
      fill={fill}
    />
  </svg>
);

export const CallsIcon = ({ fill }: IconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.15312 1.26897C4.9125 0.687716 4.27812 0.378341 3.67188 0.543966L0.921875 1.29397C0.378125 1.44397 0 1.93772 0 2.50022C0 10.2315 6.26875 16.5002 14 16.5002C14.5625 16.5002 15.0563 16.1221 15.2063 15.5783L15.9563 12.8283C16.1219 12.2221 15.8125 11.5877 15.2312 11.3471L12.2312 10.0971C11.7219 9.88459 11.1313 10.0315 10.7844 10.4596L9.52188 12.0002C7.32188 10.9596 5.54063 9.17834 4.5 6.97834L6.04063 5.71897C6.46875 5.36897 6.61562 4.78147 6.40312 4.27209L5.15312 1.27209V1.26897Z"
      fill={fill}
    />
  </svg>
);

export const ChatsIcon = ({ fill }: IconProps) => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_829_4715)">
      <path
        d="M6.50034 11.5C10.091 11.5 13.0003 9.0375 13.0003 6C13.0003 2.9625 10.091 0.5 6.50034 0.5C2.90972 0.5 0.000342014 2.9625 0.000342014 6C0.000342014 7.20625 0.459717 8.32187 1.23784 9.23125C1.12847 9.525 0.965967 9.78438 0.794092 10.0031C0.644092 10.1969 0.490967 10.3469 0.378467 10.45C0.322217 10.5 0.275342 10.5406 0.244092 10.5656C0.228467 10.5781 0.215967 10.5875 0.209717 10.5906L0.203467 10.5969C0.031592 10.725 -0.043408 10.95 0.025342 11.1531C0.094092 11.3562 0.284717 11.5 0.500342 11.5C1.18159 11.5 1.86909 11.325 2.44097 11.1094C2.72847 11 2.99722 10.8781 3.23159 10.7531C4.19097 11.2281 5.30659 11.5 6.50034 11.5ZM14.0003 6C14.0003 9.50937 10.9035 12.1531 7.23472 12.4688C7.99409 14.7937 10.5128 16.5 13.5003 16.5C14.6941 16.5 15.8097 16.2281 16.7722 15.7531C17.0066 15.8781 17.2722 16 17.5597 16.1094C18.1316 16.325 18.8191 16.5 19.5003 16.5C19.716 16.5 19.9097 16.3594 19.9753 16.1531C20.041 15.9469 19.9691 15.7219 19.7941 15.5938L19.7878 15.5875C19.7816 15.5812 19.7691 15.575 19.7535 15.5625C19.7222 15.5375 19.6753 15.5 19.6191 15.4469C19.5066 15.3438 19.3535 15.1938 19.2035 15C19.0316 14.7812 18.8691 14.5187 18.7597 14.2281C19.5378 13.3219 19.9972 12.2063 19.9972 10.9969C19.9972 8.09687 17.3441 5.71875 13.9785 5.5125C13.991 5.67188 13.9972 5.83437 13.9972 5.99687L14.0003 6Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_829_4715">
        <path d="M0 0.5H20V16.5H0V0.5Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TechIcons = {
  React: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg
      width="25"
      height="22"
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.3531 7.30664C20.1 7.22226 19.8469 7.14258 19.5938 7.06758C19.6359 6.89414 19.6734 6.7207 19.7109 6.54727C20.2875 3.75352 19.9078 1.5082 18.6281 0.767578C17.3953 0.0597654 15.3844 0.795703 13.35 2.56758C13.1484 2.74102 12.9516 2.92383 12.7641 3.10664C12.6375 2.98477 12.5063 2.86289 12.375 2.7457C10.2422 0.851953 8.10469 0.055078 6.825 0.80039C5.59688 1.51289 5.23125 3.62695 5.74687 6.2707C5.79844 6.5332 5.85469 6.79102 5.92031 7.05352C5.62031 7.13789 5.325 7.23164 5.04844 7.33008C2.54531 8.19726 0.75 9.56602 0.75 10.9816C0.75 12.4441 2.6625 13.9113 5.26406 14.802C5.475 14.8723 5.68594 14.9426 5.90156 15.0035C5.83125 15.2848 5.77031 15.5613 5.71406 15.8473C5.22188 18.4488 5.60625 20.5113 6.83438 21.2191C8.1 21.9504 10.2281 21.2004 12.3 19.3863C12.4641 19.241 12.6281 19.091 12.7922 18.9316C12.9984 19.1332 13.2141 19.3254 13.4297 19.5129C15.4359 21.2379 17.4188 21.9363 18.6422 21.2285C19.9078 20.4973 20.3203 18.2801 19.7859 15.5801C19.7437 15.3738 19.6969 15.1629 19.6453 14.9473C19.7953 14.9051 19.9406 14.8582 20.0859 14.8113C22.7906 13.916 24.75 12.4676 24.75 10.9816C24.75 9.56133 22.9031 8.1832 20.3531 7.30664ZM14.0109 3.32695C15.7547 1.8082 17.3813 1.21289 18.1219 1.63945C18.9141 2.09414 19.2188 3.93164 18.7219 6.3457C18.6891 6.50508 18.6562 6.65976 18.6141 6.81445C17.5734 6.58008 16.5187 6.41133 15.4594 6.31758C14.85 5.4457 14.1844 4.61133 13.4625 3.82852C13.6453 3.65508 13.8234 3.49102 14.0109 3.32695ZM8.5875 13.4145C8.82656 13.8223 9.07031 14.2301 9.32812 14.6285C8.59688 14.5488 7.87031 14.4316 7.15313 14.277C7.35938 13.602 7.61719 12.9035 7.91719 12.191C8.13281 12.6035 8.35312 13.0113 8.5875 13.4145ZM7.16719 7.77539C7.84219 7.62539 8.55937 7.50351 9.30469 7.40976C9.05625 7.79883 8.8125 8.19727 8.58281 8.60039C8.35313 8.99883 8.12812 9.40664 7.91719 9.81914C7.62187 9.1207 7.37344 8.43633 7.16719 7.77539ZM8.45156 11.0051C8.76094 10.3582 9.09844 9.72539 9.45469 9.10195C9.81094 8.47852 10.1953 7.87383 10.5984 7.27852C11.3016 7.22695 12.0188 7.19883 12.75 7.19883C13.4812 7.19883 14.2031 7.22695 14.9016 7.27852C15.3 7.86914 15.6797 8.47383 16.0406 9.09258C16.4016 9.71133 16.7391 10.3441 17.0578 10.9863C16.7437 11.6332 16.4062 12.2707 16.0453 12.8988C15.6891 13.5223 15.3094 14.127 14.9109 14.727C14.2125 14.7785 13.4859 14.802 12.75 14.802C12.0141 14.802 11.3016 14.7785 10.6125 14.7363C10.2047 14.141 9.82031 13.5316 9.45938 12.9082C9.09844 12.2848 8.76562 11.652 8.45156 11.0051ZM16.9172 13.4051C17.1562 12.9926 17.3813 12.5754 17.6016 12.1535C17.9016 12.8332 18.1641 13.5223 18.3937 14.2301C17.6672 14.3941 16.9312 14.5207 16.1906 14.6051C16.4437 14.2113 16.6828 13.8082 16.9172 13.4051ZM17.5922 9.81914C17.3719 9.40664 17.1469 8.99414 16.9125 8.59101C16.6828 8.19258 16.4438 7.79883 16.1953 7.40976C16.95 7.50351 17.6719 7.63008 18.3469 7.78476C18.1313 8.47851 17.8781 9.15351 17.5922 9.81914ZM12.7594 4.5457C13.2516 5.08008 13.7156 5.64258 14.1469 6.22383C13.2187 6.18164 12.2859 6.18164 11.3578 6.22383C11.8172 5.61914 12.2906 5.05664 12.7594 4.5457ZM7.32187 1.67227C8.10938 1.21289 9.85781 1.86914 11.7 3.50039C11.8172 3.60352 11.9344 3.71602 12.0562 3.82852C11.3297 4.61133 10.6594 5.4457 10.0453 6.31758C8.98594 6.41133 7.93594 6.57539 6.89531 6.80508C6.83438 6.56602 6.78281 6.32227 6.73125 6.07852C6.29063 3.80977 6.58125 2.09883 7.32187 1.67227ZM6.17344 14.0285C5.97656 13.9723 5.78438 13.9113 5.59219 13.8457C4.59375 13.5316 3.45937 13.0348 2.63906 12.3832C2.16562 12.0551 1.84687 11.5488 1.75781 10.9816C1.75781 10.1238 3.23906 9.02695 5.37656 8.28164C5.64375 8.18789 5.91563 8.10352 6.1875 8.02383C6.50625 9.04101 6.89062 10.0395 7.33594 11.0051C6.88594 11.9848 6.49687 12.9973 6.17344 14.0285ZM11.6391 18.6223C10.8656 19.3301 9.97031 19.8926 8.99531 20.277C8.475 20.5254 7.875 20.5488 7.34063 20.3379C6.59531 19.9066 6.28594 18.252 6.70781 16.0254C6.75938 15.7629 6.81563 15.5004 6.88125 15.2426C7.93125 15.4676 8.99062 15.6223 10.0641 15.702C10.6828 16.5785 11.3625 17.4176 12.0891 18.2051C11.9391 18.3504 11.7891 18.491 11.6391 18.6223ZM12.7875 17.4832C12.3094 16.9676 11.8313 16.3957 11.3672 15.7816C11.8172 15.8004 12.2812 15.8098 12.75 15.8098C13.2328 15.8098 13.7062 15.8004 14.175 15.777C13.7437 16.3723 13.2797 16.9395 12.7875 17.4832ZM18.9141 18.8895C18.8719 19.4613 18.5906 19.9957 18.1406 20.3566C17.3953 20.7879 15.8063 20.2254 14.0906 18.7535C13.8938 18.5848 13.6969 18.402 13.4953 18.2145C14.2125 17.4223 14.8734 16.5832 15.4734 15.702C16.5469 15.6129 17.6156 15.4488 18.6703 15.2098C18.7172 15.402 18.7594 15.5941 18.7969 15.7816C19.0266 16.7941 19.0641 17.8488 18.9141 18.8895ZM19.7672 13.8504C19.6359 13.8926 19.5047 13.9348 19.3688 13.9723C19.0406 12.9504 18.6375 11.952 18.1734 10.9816C18.6234 10.0254 19.0031 9.04101 19.3219 8.0332C19.5656 8.10351 19.8 8.17851 20.025 8.25351C22.2094 9.00352 23.7422 10.1191 23.7422 10.9723C23.7422 11.891 22.1063 13.077 19.7672 13.8504ZM12.75 13.1473C13.9359 13.1473 14.8969 12.1863 14.8969 11.0004C14.8969 9.81445 13.9359 8.85351 12.75 8.85351C11.5641 8.85351 10.6031 9.81445 10.6031 11.0004C10.6031 12.1863 11.5641 13.1473 12.75 13.1473Z"
        fill={color}
      />
    </svg>
  ),

  Python: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M11.914 0C5.82 0 6.2 2.656 6.2 2.656l.007 2.752h5.814v.826H3.9S0 5.789 0 11.969c0 6.18 3.403 5.96 3.403 5.96h2.034v-2.867s-.109-3.42 3.365-3.42h5.762s3.257.052 3.257-3.153V3.202S18.28 0 11.914 0zM8.708 1.567c.65 0 1.179.534 1.179 1.194 0 .66-.529 1.2-1.179 1.2-.65 0-1.179-.54-1.179-1.2 0-.66.529-1.194 1.179-1.194z" />
      <path d="M12.087 24c6.092 0 5.712-2.656 5.712-2.656l-.007-2.752h-5.814v-.826h8.121s4.1.445 4.1-5.735c0-6.18-3.403-5.96-3.403-5.96h-2.034v2.867s.109 3.42-3.365 3.42H9.635s-3.257-.052-3.257 3.153v5.287S5.92 24 12.087 24zm3.206-1.567c-.65 0-1.179-.534-1.179-1.194 0-.66.529-1.2 1.179-1.2.65 0 1.179.54 1.179 1.2 0 .66-.529 1.194-1.179 1.194z" />
    </svg>
  ),

  JavaScript: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z" />
    </svg>
  ),

  NodeJS: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M11.998,24c-0.321,0-0.641-0.084-0.922-0.247l-2.936-1.737c-0.438-0.245-0.224-0.332-0.08-0.383 c0.585-0.203,0.703-0.25,1.328-0.604c0.065-0.037,0.151-0.023,0.218,0.017l2.256,1.339c0.082,0.045,0.197,0.045,0.272,0l8.795-5.076 c0.082-0.047,0.134-0.141,0.134-0.238V6.921c0-0.099-0.053-0.192-0.137-0.242l-8.791-5.072c-0.081-0.047-0.189-0.047-0.271,0 L3.075,6.68C2.99,6.729,2.936,6.825,2.936,6.921v10.15c0,0.097,0.054,0.189,0.139,0.235l2.409,1.392 c1.307,0.654,2.108-0.116,2.108-0.89V7.787c0-0.142,0.114-0.253,0.256-0.253h1.115c0.139,0,0.255,0.112,0.255,0.253v10.021 c0,1.745-0.95,2.745-2.604,2.745c-0.508,0-0.909,0-2.026-0.551L2.28,18.675c-0.57-0.329-0.922-0.945-0.922-1.604V6.921 c0-0.659,0.353-1.275,0.922-1.603l8.795-5.082c0.557-0.315,1.296-0.315,1.848,0l8.794,5.082c0.570,0.329,0.924,0.944,0.924,1.603 v10.15c0,0.659-0.354,1.273-0.924,1.604l-8.794,5.078C12.643,23.916,12.324,24,11.998,24z M19.099,13.993 c0-1.9-1.284-2.406-3.987-2.763c-2.731-0.361-3.009-0.548-3.009-1.187c0-0.528,0.235-1.233,2.258-1.233 c1.807,0,2.473,0.389,2.747,1.607c0.024,0.115,0.129,0.199,0.247,0.199h1.141c0.071,0,0.138-0.031,0.186-0.081 c0.048-0.054,0.074-0.123,0.067-0.196c-0.177-2.098-1.571-3.076-4.388-3.076c-2.508,0-4.004,1.058-4.004,2.833 c0,1.925,1.488,2.457,3.895,2.695c2.88,0.282,3.103,0.703,3.103,1.269c0,0.983-0.789,1.402-2.642,1.402 c-2.327,0-2.839-0.584-3.011-1.742c-0.02-0.124-0.126-0.215-0.253-0.215h-1.137c-0.141,0-0.254,0.112-0.254,0.253 c0,1.482,0.806,3.248,4.655,3.248C17.501,17.007,19.099,15.91,19.099,13.993z" />
    </svg>
  ),

  TypeScript: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z" />
    </svg>
  ),

  Java: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M8.851 18.56s-.917.534.653.714c1.902.218 2.874.187 4.969-.211 0 0 .552.346 1.321.646-4.699 2.013-10.633-.118-6.943-1.149M8.276 15.933s-1.028.761.542.924c2.032.209 3.636.227 6.413-.308 0 0 .384.389.987.602-5.679 1.661-12.007.13-7.942-1.218M13.116 11.475c1.158 1.333-.304 2.533-.304 2.533s2.939-1.518 1.589-3.418c-1.261-1.772-2.228-2.652 3.007-5.688 0-.001-8.216 2.051-4.292 6.573M19.33 20.504s.679.559-.747.991c-2.712.822-11.288 1.069-13.669.033-.856-.373.75-.89 1.254-.998.527-.114.828-.093.828-.093-.953-.671-6.156 1.317-2.643 1.887 9.58 1.553 17.462-.7 14.977-1.82M9.292 13.21s-4.362 1.036-1.544 1.412c1.189.159 3.561.123 5.77-.062 1.806-.152 3.618-.477 3.618-.477s-.637.272-1.098.587c-4.429 1.165-12.986.623-10.522-.568 2.082-1.006 3.776-.892 3.776-.892M17.116 17.584c4.503-2.34 2.421-4.589.968-4.285-.355.074-.515.138-.515.138s.132-.207.385-.297c2.875-1.011 5.086 2.981-.928 4.562 0-.001.07-.062.09-.118M14.401 0s2.494 2.494-2.365 6.33c-3.896 3.077-.888 4.832-.001 6.836-2.274-2.053-3.943-3.858-2.824-5.539 1.644-2.469 6.197-3.665 5.19-7.627M9.734 23.924c4.322.277 10.959-.153 11.116-2.198 0 0-.302.775-3.572 1.391-3.688.694-8.239.613-10.937.168 0-.001.553.457 3.393.639" />
    </svg>
  ),

  Angular: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M9.931 12.645h4.138l-2.07-4.908m0-7.737L.68 3.982l1.726 14.771L12 24l9.596-5.242L23.32 3.984 11.999.001zm7.064 18.31h-2.638l-1.422-3.503H8.995L7.573 18.956H4.937l7.06-16.912L19.995 18.31z" />
    </svg>
  ),

  Vue: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M24,1.61H14.06L12,5.16,9.94,1.61H0L12,22.39ZM12,14.08,5.16,2.23H9.59L12,6.41l2.41-4.18h4.43Z" />
    </svg>
  ),

  Docker: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg
      width="31"
      height="24"
      viewBox="0 0 31 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_798_3010)">
        <path
          d="M17.1517 11.0766H14.0532V8.29219H17.1517V11.0766ZM17.1517 1.5H14.0532V4.34531H17.1517V1.5ZM20.8173 8.2875H17.7188V11.0719H20.8173V8.2875ZM13.4907 4.90781H10.3923V7.725H13.4907V4.90781ZM17.1517 4.90781H14.0532V7.725H17.1517V4.90781ZM30.1267 9.59531C29.4517 9.14062 27.8954 8.97656 26.7001 9.20156C26.5454 8.07656 25.9173 7.09688 24.7735 6.21563L24.1173 5.77969L23.6813 6.43594C22.8188 7.73906 22.5845 9.88594 23.5079 11.3016C23.1001 11.5219 22.2985 11.8219 21.2392 11.8031H0.86259C0.454778 14.1844 1.13447 17.2781 2.92509 19.4016C4.66415 21.4594 7.2704 22.5047 10.6782 22.5047C18.0563 22.5047 23.5173 19.1062 26.072 12.9328C27.0751 12.9516 29.2407 12.9375 30.3517 10.8141C30.422 10.6969 30.661 10.1953 30.7501 10.0125L30.1267 9.59531ZM6.16884 8.2875H3.07509V11.0719H6.17353V8.2875H6.16884ZM9.82978 8.2875H6.73134V11.0719H9.82978V8.2875ZM13.4907 8.2875H10.3923V11.0719H13.4907V8.2875ZM9.82978 4.90781H6.73134V7.725H9.82978V4.90781Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_798_3010">
          <path d="M0.75 0H30.75V24H0.75V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Django: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg className={className} viewBox="0 0 24 24" fill={color}>
      <path d="M11.146 0h3.924v18.166c-2.013.382-3.491.535-5.096.535-4.791 0-7.288-2.166-7.288-6.32 0-4.001 2.65-6.6 6.753-6.6.637 0 1.121.051 1.707.204V0zm0 9.143a3.894 3.894 0 00-1.325-.204c-1.988 0-3.134 1.223-3.134 3.364 0 2.09 1.096 3.236 3.109 3.236.433 0 .79-.025 1.35-.102V9.143zM21.314 6.06v9.098c0 3.134-.229 4.638-.917 5.937-.637 1.249-1.478 2.039-3.211 2.905l-3.644-1.733c1.733-.815 2.574-1.53 3.109-2.625.561-1.121.739-2.421.739-5.835V6.059h3.924zM17.39.021h3.924v4.026H17.39V.021z" />
    </svg>
  ),
  AL: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9375 0C15.1102 0 16.875 1.76484 16.875 3.9375V32.0625C16.875 34.2352 15.1102 36 12.9375 36C10.9055 36 9.23203 34.4602 9.02109 32.4773C8.65547 32.5758 8.26875 32.625 7.875 32.625C5.39297 32.625 3.375 30.607 3.375 28.125C3.375 27.6047 3.46641 27.0984 3.62812 26.6344C1.50469 25.8328 0 23.7797 0 21.375C0 19.132 1.31484 17.1914 3.22031 16.2914C2.60859 15.525 2.25 14.5547 2.25 13.5C2.25 11.3414 3.76875 9.54141 5.79375 9.09844C5.68125 8.71172 5.625 8.29688 5.625 7.875C5.625 5.77266 7.07344 4.00078 9.02109 3.50859C9.23203 1.53984 10.9055 0 12.9375 0ZM23.0625 0C25.0945 0 26.7609 1.53984 26.9789 3.50859C28.9336 4.00078 30.375 5.76562 30.375 7.875C30.375 8.29688 30.3188 8.71172 30.2063 9.09844C32.2313 9.53437 33.75 11.3414 33.75 13.5C33.75 14.5547 33.3914 15.525 32.7797 16.2914C34.6852 17.1914 36 19.132 36 21.375C36 23.7797 34.4953 25.8328 32.3719 26.6344C32.5336 27.0984 32.625 27.6047 32.625 28.125C32.625 30.607 30.607 32.625 28.125 32.625C27.7313 32.625 27.3445 32.5758 26.9789 32.4773C26.768 34.4602 25.0945 36 23.0625 36C20.8898 36 19.125 34.2352 19.125 32.0625V3.9375C19.125 1.76484 20.8898 0 23.0625 0Z"
        fill="#FF6646"
      />
    </svg>
  ),
  Ruby: ({ className = 'w-6 h-6', color = '#FF6646' }) => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_798_2871)">
        <path
          d="M4.83767 1.56523C4.99587 1.35078 5.249 1.2207 5.51619 1.2207H13.9537C14.2209 1.2207 14.474 1.34727 14.6322 1.56523L18.5697 6.90898C18.8088 7.23242 18.7842 7.67891 18.517 7.97773L10.3607 16.9777C10.2025 17.1535 9.974 17.2555 9.73494 17.2555C9.49587 17.2555 9.27087 17.1535 9.10916 16.9777L0.952906 7.97773C0.682203 7.67891 0.661109 7.23242 0.900172 6.90898L4.83767 1.56523ZM6.19119 2.96445C6.07517 3.05234 6.04353 3.21055 6.11736 3.33359L8.13533 6.69453L2.96033 7.12695C2.81619 7.1375 2.70369 7.26055 2.70369 7.4082C2.70369 7.55586 2.81619 7.67539 2.96033 7.68945L9.71033 8.25195C9.72439 8.25195 9.74197 8.25195 9.75603 8.25195L16.506 7.68945C16.6502 7.67891 16.7627 7.55586 16.7627 7.4082C16.7627 7.26055 16.6502 7.14102 16.506 7.12695L11.3345 6.69805L13.3525 3.33711C13.4263 3.21406 13.3947 3.05234 13.2787 2.96797C13.1627 2.88359 13.001 2.89766 12.9025 3.00312L9.73494 6.43086L6.56736 2.99961C6.46892 2.89414 6.3072 2.88008 6.19119 2.96445Z"
          fill="#FF6646"
        />
      </g>
      <defs>
        <clipPath id="clip0_798_2871">
          <path
            d="M0.734375 0.376953H18.7344V18.377H0.734375V0.376953Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  ),
};

export const ShieldCheckIcon = ({ fill }: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.56251 0C6.68829 0 6.81407 0.0273438 6.92892 0.0792969L12.0777 2.26406C12.6793 2.51836 13.1277 3.11172 13.125 3.82812C13.1113 6.54063 11.9957 11.5035 7.28439 13.7594C6.82775 13.9781 6.29728 13.9781 5.84064 13.7594C1.12931 11.5035 0.0136843 6.54063 1.24373e-05 3.82812C-0.00272194 3.11172 0.445716 2.51836 1.04728 2.26406L6.19884 0.0792969C6.31095 0.0273438 6.43673 0 6.56251 0ZM6.56251 1.82656V12.1625C10.3359 10.3359 11.3504 6.2918 11.375 3.86641L6.56251 1.82656Z"
      fill={fill}
    />
  </svg>
);

export const CardIcon = ({ fill }: IconProps) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2.1875C14.2406 2.1875 14.4375 2.38437 14.4375 2.625V3.5H1.3125V2.625C1.3125 2.38437 1.50937 2.1875 1.75 2.1875H14ZM14.4375 6.125V11.375C14.4375 11.6156 14.2406 11.8125 14 11.8125H1.75C1.50937 11.8125 1.3125 11.6156 1.3125 11.375V6.125H14.4375ZM1.75 0.875C0.784766 0.875 0 1.65977 0 2.625V11.375C0 12.3402 0.784766 13.125 1.75 13.125H14C14.9652 13.125 15.75 12.3402 15.75 11.375V2.625C15.75 1.65977 14.9652 0.875 14 0.875H1.75ZM3.28125 9.1875C2.91758 9.1875 2.625 9.48008 2.625 9.84375C2.625 10.2074 2.91758 10.5 3.28125 10.5H4.59375C4.95742 10.5 5.25 10.2074 5.25 9.84375C5.25 9.48008 4.95742 9.1875 4.59375 9.1875H3.28125ZM6.78125 9.1875C6.41758 9.1875 6.125 9.48008 6.125 9.84375C6.125 10.2074 6.41758 10.5 6.78125 10.5H9.84375C10.2074 10.5 10.5 10.2074 10.5 9.84375C10.5 9.48008 10.2074 9.1875 9.84375 9.1875H6.78125Z"
      fill={fill}
    />
  </svg>
);

export const HouseIcon = ({ fill }: IconProps) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.72748 0L0 7.23888H2.06352V15.8789H15.0235V7.23888H17.28L8.72748 0ZM10.6826 13.3589H6.597L7.4538 9.50292C6.93576 9.14292 6.597 8.60076 6.597 7.93692C6.597 6.84324 7.51176 5.97888 8.63964 5.97888C9.76824 5.97888 10.6826 6.87636 10.6826 7.97004C10.6826 8.63424 10.3439 9.13824 9.8262 9.49716L10.6826 13.3589Z"
      fill="#999999"
    />
  </svg>
);

export const PersonIcon = ({ fill }: IconProps) => (
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 0C4.11594 0 3.2681 0.351189 2.64298 0.976311C2.01786 1.60143 1.66667 2.44928 1.66667 3.33333C1.66667 4.21739 2.01786 5.06523 2.64298 5.69036C3.2681 6.31548 4.11594 6.66667 5 6.66667C5.88406 6.66667 6.7319 6.31548 7.35702 5.69036C7.98214 5.06523 8.33333 4.21739 8.33333 3.33333C8.33333 2.44928 7.98214 1.60143 7.35702 0.976311C6.7319 0.351189 5.88406 0 5 0ZM3.33333 7.5C2.44928 7.5 1.60143 7.85119 0.976311 8.47631C0.351189 9.10143 0 9.94928 0 10.8333V11.6667C0 12.1087 0.175595 12.5326 0.488155 12.8452C0.800716 13.1577 1.22464 13.3333 1.66667 13.3333H8.33333C8.77536 13.3333 9.19928 13.1577 9.51184 12.8452C9.8244 12.5326 10 12.1087 10 11.6667V10.8333C10 9.94928 9.64881 9.10143 9.02369 8.47631C8.39857 7.85119 7.55072 7.5 6.66667 7.5H3.33333Z"
      fill="#999999"
    />
  </svg>
);

export const CircleInfo = FaCircleInfo as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const PlayIcon = FaPlay as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CameraIcon = HiCamera as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const ListIcon = FaListUl as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const GridIcon = PiGridFour as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MessageLine2 = RiMessage2Line as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const WarnIcon = RiErrorWarningFill as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CalendarIcon = CiCalendarDate as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const GrLinkPreviousIcon = GrLinkPrevious as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const GrLinkNextIcon = GrLinkNext as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const IoIosFlashIcon = IoIosFlash as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CheckMarkIcon = IoMdCheckmarkCircle as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const Star = FaStar as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const TimeIcon = MdAccessTimeFilled as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MailIcon = IoMail as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
